import { useEffect, useMemo, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { generateSeries } from '../../services/retirementPlanning';

const generateOptions = ({
  ageRange,
  iRetAge,
  opposite,
}: {
  ageRange: number[];
  iRetAge: number;
  opposite: boolean;
}) => ({
  chart: {
    height: 350,
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  legend: {
    show: true,
    offsetX: 20,
    offsetY: 7,
    markers: {
      width: 12,
      height: 12,
    },
  },
  toolbar: {
    show: false,
  },
  xaxis: {
    categories: ageRange,
    tickAmount: 8,
    title: {
      text: 'Your Age',
      offsetY: -3,
      style: {
        fontFamily: 'Roboto',
        fontWeight: '400',
        color: '#777777',
      },
    },
  },
  colors: ['#9DB4C0', '#B58D00', '#FCCE00', '#165DFF'],

  // Please uncomment lines below, to hide the tooltip:
  // tooltip: {
  //   enabled: false,
  // },
  annotations: {
    xaxis: [
      {
        x: iRetAge,
        strokeDashArray: 0,
        borderColor: '#165DFF',
      },
      {
        x: iRetAge,
        x2: 100,
        fillColor: 'rgba(22, 93, 255, 0.2)',
        opacity: 0.4,
      },
    ],
  },
  yaxis: {
    type: 'number',
    opposite: true,
    title: {
      text: '',
    },
    labels: {
      formatter: function (a: any) {
        return `$${a.toLocaleString()}`;
      },
    },

    categories: ['0', '50,000', '100,000', '150,000', '200,000', '250,000'],
  },

  zoom: {
    enabled: false,
  },
});

const AreaMixedChart = ({
  cAge,
  ageRange,
  iROR,
  iEECont,
  iRetAge,
  cHSA,
  cPS,
  cPay,
  c401k,
  SScal,
  iIncRep,
  Inf,
  oppositeAxis,
}: {
  cAge: number;
  ageRange: number[];
  iROR: number;
  iEECont: number;
  iRetAge: number;
  cHSA: number;
  cPS: number;
  cPay: number;
  c401k: number;
  SScal: number;
  iIncRep: number;
  Inf: number;
  oppositeAxis?: boolean;
}) => {
  const [series, setSeries] = useState<any>([]);

  useEffect(() => {
    const _to = setTimeout(() => {
      setSeries(
        generateSeries({
          chartType: 'area',
          cAge,
          ageRange,
          iROR,
          iEECont,
          iRetAge,
          cHSA,
          cPS,
          cPay,
          c401k,
          SScal,
          iIncRep,
          Inf,
        })
      );
    }, 500);

    return () => {
      clearTimeout(_to);
    };
  }, [
    cAge,
    ageRange,
    iROR,
    iEECont,
    iRetAge,
    cHSA,
    cPS,
    cPay,
    c401k,
    SScal,
    iIncRep,
    Inf,
  ]);

  const options = useMemo(
    () =>
      generateOptions({
        ageRange,
        iRetAge,
        opposite: oppositeAxis ? oppositeAxis : false,
      }),
    [ageRange, iRetAge, oppositeAxis]
  );

  return (
    <div>
      <ReactApexChart
        options={options}
        type="area"
        curve="smooth"
        series={series}
      />
    </div>
  );
};
export default AreaMixedChart;
